/**
 * Bonus taux de chroma lié au niveau NG+ — partagé client / serveur.
 */

export const ASCENSION_SHINY_MULT_PER_LEVEL = 0.06
export const ASCENSION_SHINY_MULT_CAP_LEVEL = 20

/** Multiplicateur relatif au taux de base (1 = pas de bonus NG+). */
export function getAscensionShinyMult(ascensionLevel: number): number {
  const effective = Math.min(
    ASCENSION_SHINY_MULT_CAP_LEVEL,
    Math.max(0, Math.floor(Number(ascensionLevel) || 0)),
  )
  return Math.round((1 + effective * ASCENSION_SHINY_MULT_PER_LEVEL) * 1000) / 1000
}
